import * as React from 'react';
const SvgDashboardArrowUp = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none" }, props),
    React.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "#FF7171" }),
    React.createElement("path", { fill: "#fff", d: "M6.137 11.2h1.726V6.035l2.129 2.1L11.2 6.943 7 2.8 2.8 6.943l1.208 1.192 2.129-2.1V11.2Z" })));
export default SvgDashboardArrowUp;
